<template>
  <ItemMobile v-if="$vuetify.breakpoint.smAndDown"/>
  <ItemDesktop v-else/>
</template>

<script>
	import ItemDesktop from "../components/item/ItemDesktop";
	import ItemMobile from "../components/item/ItemMobile";

	export default {
		name: "Item",

		components: {
			ItemMobile,
			ItemDesktop,
		},
	}
</script>
